import Button from '@material-ui/core/Button';
/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled, { keyframes } from 'styled-components';

/**
 * Estilização do componente opacityPulse
 */
export const opacityPulse = keyframes`
 0% {
    opacity: 1;
  }
  66% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;
/**
 * Estilização do componente InfoMessage
 */
export const InfoMessage = styled.div`
  width: 100%;
  padding-top: 5px;
  margin-left: 22px;
  text-align: left;
  /* height: 15px; */
  /* left: 501.72px;
  top: 297.14px; */

  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  line-height: 13px;

  color: #DF773D;
`;
/**
 * Estilização da div
 */
export default styled.div`
  display: flex;  
  justify-content: center;
  flex-wrap: nowrap;

  .content {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;    
  }

  aside {
    color: #5e5e5e;
    position: relative;
    height: 100%;
    width: 620px;
    display: flex;  
    justify-content: center;  
    padding-top: 48px;
    padding-bottom: 64px;    

    @media (max-width: 768px) {
      flex: 0 0 100vw;
    }

    header {
      position: absolute;
      top: 0px;
      height: 48px;
      width: 100%;
      text-align: center;      

      .content-input-geoservice {
        display: inline-block;
        width: 98%;
        height: 50px;        
        padding: 0px 16px 12px 16px;
        border: 1px solid #e5e5e5;
        border-radius: 4px;      
      }

      .MuiInput-underline {        
        &::before {
          border-bottom: 0.1px solid rgba(94, 94, 94, 0.42) !important;
        }
      }

      .text-field {
        padding: 8px 0px 0px 0px;

        input {
          font-size: 12px;
          line-height: 14px;
          width: 94%;
        }
      }

      button {
        position: absolute;
        top: 12px;
        right: 22px;
        background: none;
        cursor: pointer;
        border: none;

        &.geoservice-request {
          color: #c4c4c4;
          &:hover {
            color: #3c71dd;
          }
        }
      }
    }

    > div.list {
      height: 85%;
      width: 99%;
      margin-top: 60px;
      overflow: scroll;

      .content {
        margin-top: -18px;
      }

      @media (min-width: 768px) {
        max-width: 100%;
      }

      /* width */
      ::-webkit-scrollbar {
        width: 21px;
      }

      /* Track */
      ::-webkit-scrollbar-track {
        background: transparent;
      }

      /* Handle */
      ::-webkit-scrollbar-thumb {
        background: #d8d8d8;
        border-radius: 10px;
        border: 8px solid #fff;

        /* Handle on hover */
        &:hover {
          background: #5d5d5d;
        }
      }
    }

    footer {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 60px;

      .content {
        padding: 10px 0px 16px 0px;        
      }      

      button {
        width: 184px;
      }

      .Mui-disabled {
        background-color: #aeaeae;
        color: #ffffff;
      }
    }
  }

  > .details {
    position: relative;
    flex: 0 0 400px;
    border-left: 1px solid #e5e5e5;
    background: white;

    .metadata {
      max-height: 230px;
      overflow: auto;
      padding: 10px 30px 0 30px;
    }

    @media (max-width: 768px) {
      position: fixed;
      top: 56px;
      z-index: 5;
      height: calc(100vh - 56px);
      width: 100%;
      display: ${({ showingDetails }) => (showingDetails ? 'block' : 'none')};
      .metadata {
        max-height: calc(100vh - 276px);
        overflow: auto;
        padding: 10px 30px 10px 30px;
      }
    }

    h1 {
      font-size: 18px;
      line-height: 16px;
      margin: 25px 0 21px 0;
    }

    footer {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 60px;

      @media (max-width: 768px) {
        display: none;
      }

      .content {
        text-align: right;
        padding: 10px 0;
        border-top: 1px solid #e5e5e5;
      }
    }
  }

  .fixed_header {
    position: fixed;
    top: 0;
    width: 100%;
    background: white;
  }

  .loader {
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.8);
    color: #5e5e5e;
    z-index: 5;
    @media (max-width: 768px) {
      height: calc(50vh - 53px);
      top: 60px;
    }
  }
  //Estilização da ferramenta pesquisar no geoserviço
  .search  {
    position: absolute;
    top: 60px;
    height: 40px;
    width: 100%;
    text-align: center;   
    margin-bottom: 5px;

    .content-input-search {
      width: 98%;
      margin-left: 7px;
      height: 35px;        
      padding: 0px 16px;
      border: 1px solid #e5e5e5;
      border-radius: 4px; 
      background: #EEEEEE;     
    }

    .MuiInput-underline {        
      &:before {
        border-bottom: 0.3px solid rgba(94, 94, 94, 0.42) !important;
      }
      &:after {
        display: none;
      }
    }

    .text-field-search {
      padding: 4.3px 0px;        

      input {          
        width: 100%;
        margin-bottom: -8px;          
        font-family: 'Roboto';
        font-style: normal;
        font-size: 12px;
        line-height: 14px;
        font-weight: 400;            
        color: #5E5E5E;
      }
    }

    .geoservice-search{
      color: #B8B8B8;
      position: absolute;
      top: 4px;
      right: 22px;                
      background: transparent;
      cursor: pointer;
      border: none;
      &:hover{
        color: #3c71dd;
      }
    }
  }
`;

// TODO Criar estilos de Botão padrão para todo o sistema utilizando styledcomponents, conversar com equipe de design para padronizar padding, etc
/**
 * Estilização do componente StyledButton
 */
export const StyledButton = styled(Button)`
  width: 100%;

  &.MuiButton-root {
    text-transform: none;
    padding: 10px 20px;
    font-size: 14px;
    line-height: 16px;
  }

  &.MuiButton-contained {
    color: #fff;
    background: #3c71dd;

    &:hover {
      background: #3463c1;
    }
  }

  &:disabled {
    background: #aeaeae;
  }
`;
